import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Header from '../components/header';
import Footer from '../components/footer';
import ScrollTop from '../components/common/ScrollTop';
import Loading from '../components/common/Loading';

export default function MainLayout(): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <div id="back-to-top-anchor" />
      <Header />
      <Box
        component="main"
        sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
      >
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </Box>
      <Footer />
      <ScrollTop />
    </Box>
  );
}
